import styled from 'styled-components'

export const RequiredMark = styled.span`
	color: ${({ theme }) => theme.colors.status.error.text};
	margin-left: 2px;
`
